import { Square } from "lucide-react"
import Link from "next/link"
import { useEffect, useState } from "react"
import { Col } from "react-bootstrap"
import { ECHARTS_COLORS } from "../../constants/echarts-colors.constants"
import DoughnutChart from "./DoughnutChart"

const focusTags = {
  industries: {
    title: "Industry focus",
    label: "Target industries",
  },
  categories: {
    title: "Core services",
    label: "Core services",
  },
  subcategories: {
    title: "",
    label: "Focus areas",
  },
  platforms: {
    title: "",
    label: "Technology stacks",
  },
}

const prepareChartData = (items) => {
  let colors = ECHARTS_COLORS.concat([])

  const getColor = () => {
    const first = colors.shift()
    colors.push(first)
    return first
  }

  return items.map((item) => ({
    ...item,
    color: getColor(),
  }))
}

const CompanyFocusItem = ({ data, focusName, focusData, focusItems }) => {
  const [selectedOptions, setSelectedOptions] = useState({})
  const [selectedItems, setSelectedItems] = useState({})

  const categories = data.categories?.CAT || []

  const selectOption = (tabKey, dataKey) => {
    const selectedDataKey = dataKey ?? Object.keys(data[tabKey])[0]
    if (!selectedDataKey) return

    const items = prepareChartData(data[tabKey][selectedDataKey])

    setSelectedOptions((prev) => ({ ...prev, [tabKey]: selectedDataKey }))
    setSelectedItems((prev) => ({ ...prev, [tabKey]: items }))
  }

      useEffect(() => {
        focusItems.forEach((focus) => {
            if (data[focus.name] && Object.keys(data[focus.name]).length > 0) {
                selectOption(focus.name)
            }
        })
    }, [])


  return (
    <Col xs={12} md={6}>
      <h3 className="h6 text-gray-600 text-uppercase mb-4 fw-normal">
        {focusTags[focusName].label}
      </h3>
      <div className="mt-2 d-flex flex-column flex-xl-row gap-2 align-items-center align-items-xl-start">
        <DoughnutChart items={selectedItems[focusName] ?? []} />
        <div className="w-100">
          <ChartSelect
            focusData={focusData}
            focusName={focusName}
            categories={categories}
            selectOption={selectOption}
            selectedOption={selectedOptions[focusName]}
          />
          {FocusItemList(selectedItems[focusName] ?? [])}
        </div>
      </div>
    </Col>
  )
}

const ChartSelect = ({
  selectOption,
  selectedOption,
  focusData,
  focusName,
  categories,
}) => {
  const getGroupLabel = (name, groupvalue) => {
    return ["subcategories", "platforms"].includes(name)
      ? categories.find((category) => category.value === groupvalue)?.label ||
          ""
      : ""
  }

  const dataKeys = Object.keys(focusData)

  return dataKeys.length > 1 ? (
    <>
      <h4 id="select-core-service" className="h5">Select core service</h4>
      <select
        aria-labelledby="select-core-service"
        className="form-select mt-3 paragraph-sm"
        value={selectedOption}
        onChange={(e) => selectOption(focusName, e.target.value)}
      >
        {dataKeys.map((key) => (
          <option key={key} value={key} className="">
            {getGroupLabel(focusName, key)}
          </option>
        ))}
      </select>
    </>
  ) : null
}

//--
const FocusItemList = (items) => {
  return (
    <ul className="list-unstyled mt-3">
      {items.map((item, index) => (
        <li key={index}>
          <Square
            fill={item.color}
            stroke={item.color}
            style={{ width: "1rem", height: "1rem" }}
            className="me-2 text-center d-inline-block align-middle"
          />
          {item.url ? (
            <Link
              href={`/companies${item.url}`}
              className="paragraph-sm text-gray-600"
            >
              {item.label}
            </Link>
          ) : (
            <span className="paragraph-sm text-gray-600">{item.label}</span>
          )}
          <span className="float-end paragraph-sm text-gray-600">{`${item.percent}%`}</span>
        </li>
      ))}
    </ul>
  )
}

export default CompanyFocusItem
